import { modalState } from 'store/atom/modal-state-atom'
import { Fragment } from 'react'
import { useRecoilValue } from 'recoil'
//import useModal from 'hook/useModal'

import 'assets/css/dev.css'

/**
 * @description 모탈 Stack으로 Rendering 컨테이너
 * @author 이종술
 * @since 2023-01-01
 * 업무 : 컴포넌트 > 모달 > Modal 컨테이너
 */
export default function ModalContainer() {
  const modals = useRecoilValue(modalState)
  //const { closeModal } = useModal()

  return (
    <>
      {modals.map((item, index) => (
        <Fragment key={`modal_${index}`}>
          {/* <div
            className="popup-dim"
            onClick={
              item.props.dimClickClose ? (item.props.modalName === 'AlertModal' ? item.ok : closeModal) : () => {}
            }
          ></div> */}
          <div>
            <item.modalComp {...item.props} ok={item.ok} cancel={item.cancel} />
          </div>
        </Fragment>
      ))}
    </>
  )
}
